import { render, staticRenderFns } from "./DraggableAllocation.vue?vue&type=template&id=bb282f72&"
import script from "./DraggableAllocation.vue?vue&type=script&lang=js&"
export * from "./DraggableAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports